import { render, staticRenderFns } from "./challan.vue?vue&type=template&id=01575bfa&"
import script from "./challan.vue?vue&type=script&lang=js&"
export * from "./challan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports